import React, { createContext, useContext, useState, ReactNode } from "react";
import { Country, COUNTRIES } from "./topchef.types";

interface BackofficeCountryContextType {
  selectedCountry: Country;
  setSelectedCountry: (country: Country) => void;
}

const STORAGE_KEY = "backoffice_country";

export const BackofficeCountryContext = createContext<BackofficeCountryContextType>({
  selectedCountry: COUNTRIES[0],
  setSelectedCountry: () => {},
});

export const useBackofficeCountry = () => useContext(BackofficeCountryContext);

interface BackofficeCountryProviderProps {
  children: ReactNode;
}

export const BackofficeCountryProvider: React.FC<BackofficeCountryProviderProps> = ({ children }) => {
  const stored = localStorage.getItem(STORAGE_KEY);
  const initial = COUNTRIES.find((c) => c.code === stored) ?? COUNTRIES[0];

  const [selectedCountry, setSelectedCountryState] = useState<Country>(initial);

  const setSelectedCountry = (country: Country) => {
    localStorage.setItem(STORAGE_KEY, country.code);
    setSelectedCountryState(country);
  };

  return (
    <BackofficeCountryContext.Provider value={{ selectedCountry, setSelectedCountry }}>
      {children}
    </BackofficeCountryContext.Provider>
  );
};
